module.exports = __webpack_public_path__ + "img/info-item-3.990f5ac3.png";